import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';

@Component({
  name: 'bpc-alert',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class Alert extends mixins(AbstractField) {
  @Prop([String, Number]) readonly value: string | number;

  get model(): string | number {
    return this.value;
  }
  set model(val: string | number) {
    this.$emit('alert', val);
  }

  // updated () { }

  // destroyed () { }
}
